// Mirrors the API: once an enrollment leaves these statuses only an admin may change it.
export const guardianEditableStatuses = ['In-Progress', 'Submitted: Awaiting Documents'];

export const isGuardianEditableStatus = (status: string | null | undefined): boolean =>
    guardianEditableStatuses.includes(status ?? 'In-Progress');
